import React from 'react';
import { Link } from 'react-router-dom';
import './InventoryRecentActivity.css';

function InventoryRecentActivity() {
    return (
        <div className="inventory-recent-activity">
            <h3 className="inventory-recent-activity__title">
                <i className="fas fa-history inventory-recent-activity__icon" aria-hidden="true" />
                Atividade recente
            </h3>
            <div className="inventory-recent-activity__content">
                <p className="inventory-recent-activity__text">
                    As atividades recentes (abertura de chamados, vinculações, manutenções e anotações) são exibidas no histórico de cada ativo.
                </p>
                <Link to="/listaHisHar" className="inventory-recent-activity__cta">
                    <i className="fas fa-list-ul" aria-hidden="true" /> Ver histórico de hardwares
                </Link>
            </div>
        </div>
    );
}

export default InventoryRecentActivity;
